import { useEffect, useLayoutEffect, useMemo, useRef } from 'react'
import { useRecordingStore } from '@/store/recording.store'

type Controls = NonNullable<
  ReturnType<typeof useRecordingStore.getState>['controls']
>

/** Publish once, while invoking the latest committed session handlers. */
export function useRecordingControls(handlers: Controls) {
  const latest = useRef(handlers)
  useLayoutEffect(() => {
    latest.current = handlers
  })
  const controls = useMemo<Controls>(
    () => ({
      pause: () => latest.current.pause(),
      resume: () => latest.current.resume(),
      stop: () => latest.current.stop(),
      discard: () => latest.current.discard(),
    }),
    [],
  )
  useEffect(() => {
    useRecordingStore.getState().registerControls(controls)
    return () => {
      if (useRecordingStore.getState().controls === controls) {
        useRecordingStore.getState().registerControls(null)
      }
    }
  }, [controls])
}
